// src/hooks/useIsDesktop.js
// Vrai si le viewport est au moins au breakpoint 'lg' de Tailwind (1024px).
// Pour les cas où le responsive ne peut pas se faire en CSS seul (rendus
// conditionnels : un rail pliable n'a pas de sens sur un écran de 360px).
import { useEffect, useState } from "react";

export const DESKTOP_MIN = 1024;

export default function useIsDesktop(min = DESKTOP_MIN) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window === "undefined" || window.innerWidth >= min
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${min}px)`);
    const onChange = (e) => setIsDesktop(e.matches);
    setIsDesktop(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [min]);

  return isDesktop;
}
